import React, { useState, useEffect } from "react";
import axios from "axios";
import GradientButton from '../../../components/GradientButton/GradientButton';
import CancelButton from '../../../components/CancelButton/CancelButton';
import ConfirmModal from '../../../components/ConfirmModal/ConfirmModal';

const OriginForm = ({ initialData = {}, onSuccess, onCancel }) => {
  const [formData, setFormData] = useState({
    id: "",
    company_name: "",
    municipal_name: "",
    department_code: "",
    department_name: "",
    actor_type: "",
    certified: "",
    ...initialData,
  });

  const [modal, setModal] = useState({ open: false, type: "error", title: "", message: "" });

  useEffect(() => {
    setFormData((prev) => ({ ...prev, ...initialData }));
  }, [initialData]);

  const closeModal = () => setModal((prev) => ({ ...prev, open: false }));


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("access_token");

      if (initialData && initialData._id) {
        formData.id = initialData._id;
        await axios.put(
          `${process.env.REACT_APP_API_URL}/origins/update/${initialData._id}`,
          formData,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/origins/create`,
          formData,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }

      if (onSuccess) onSuccess();
    } catch (err) {
      console.error("Error en formulario de origen:", err);
      const backendMessage =
        err.response?.data?.errors?.[0] ||
        err.response?.data?.message ||
        "Ocurrió un error inesperado. Intenta nuevamente.";

      setModal({
        open: true,
        type: "error",
        title: "Error al guardar",
        message: backendMessage,
      });
    }
  };

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className="bg-white px-6 py-6 rounded-lg shadow-md flex flex-col gap-4 text-gray-700 font-sans w-full"
      >
        {/* Grid de 2 columnas */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="flex flex-col">
            <label htmlFor="company_name" className="text-gray-600 mb-1">
              Nombre de la empresa
            </label>
            <input
              type="text"
              name="company_name"
              id="company_name"
              value={formData.company_name}
              onChange={handleChange}
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="municipal_name" className="text-gray-600 mb-1">
              Municipio
            </label>
            <input
              type="text"
              name="municipal_name"
              id="municipal_name"
              value={formData.municipal_name}
              onChange={handleChange}
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="department_code" className="text-gray-600 mb-1">
              Código del departamento
            </label>
            <input
              type="text"
              name="department_code"
              id="department_code"
              value={formData.department_code}
              onChange={handleChange}
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="department_name" className="text-gray-600 mb-1">
              Nombre del departamento
            </label>
            <input
              type="text"
              name="department_name"
              id="department_name"
              value={formData.department_name}
              onChange={handleChange}
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="actor_type" className="text-gray-600 mb-1">
              Tipo de actor
            </label>
            <input
              type="text"
              name="actor_type"
              id="actor_type"
              value={formData.actor_type}
              onChange={handleChange}
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="certified" className="text-gray-600 mb-1">
              Certificado
            </label>
            <input
              type="text"
              name="certified"
              id="certified"
              value={formData.certified}
              onChange={handleChange}
              className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
          </div>
        </div>

        {/* Botones */}
        <div className="flex gap-2 mt-4">
          <GradientButton
            type="submit"
          >
            {initialData._id ? "Guardar" : "Crear"}
          </GradientButton>
          <CancelButton onClick={onCancel} />
        </div>
      </form>
      <ConfirmModal
        isOpen={modal.open}
        type={modal.type}
        title={modal.title}
        message={modal.message}
        confirmText="Aceptar"
        onConfirm={closeModal} // 👈 con type="error" solo se renderiza este botón
      />
    </>
  );
};

export default OriginForm;
